import React, { Component } from "react";
import Dropdown from "./Dropdown";
import { Grid, Row, Col } from "react-bootstrap";
import "./option.scss";

export default class Options extends Component {
  constructor(props) {
    super(props);
    this.state = {
      hudrleRate: hudrleRateArray[0].value,
      rwaMrBase: rwaMrArray[0].value,
      rwaCcrBase: rwaCcrArray[0].value,
      rwaCvaBase: rwaCvaArray[0].value,
      rwaCorBase: rwaCorArray[0].value,
      rwaIrrbbBase: rwaIrrbbArray[0].value,
    };
  }
  onChange(name, value) {
    this.setState({ [name]: value });
  }
  render() {
    return (
      <Grid fluid>
        {/* ── Section 1: Hurdle Rate ──────────────────────────── */}
        <div style={{ marginBottom: 20 }}>
          <Row className="show-grid">
            <Col xs={12} md={12}>
              <text style={{ fontWeight: 600 }}>Hurdle rate</text>
            </Col>
          </Row>
          <Row className="show-grid">
            <Col xs={12} md={4}>
              <Dropdown
                title="Hurdle rate"
                options={hudrleRateArray}
                value={this.state.hudrleRate}
                onChange={(value) => this.onChange("hudrleRate", value)}
              />
            </Col>
          </Row>
        </div>

        {/* ── Section 2: Parameter Selection ─────────────────── */}
        <div
          style={{
            border: "1.5px solid #e2e8f0",
            borderRadius: 10,
            padding: "16px 16px 8px",
            background: "#f8fafc",
            marginBottom: 8,
          }}
        >
          <div style={{ marginBottom: 14 }}>
            <span
              style={{
                fontWeight: 700,
                fontSize: 14,
                color: "#1e293b",
                letterSpacing: "0.01em",
              }}
            >
              Parameter Selection
            </span>
          </div>

          {/* Baseline Capital */}
          <Row className="show-grid">
            <Col xs={12} md={12}>
              <text style={{ fontWeight: 600 }}>Baseline Capital</text>
            </Col>
          </Row>
          <Row className="show-grid">
            <Col xs={12} md={4}>
              <Dropdown
                title="RWA MR"
                options={rwaMrArray}
                onChange={(value) => this.onChange("rwaMrBase", value)}
                value={this.state.rwaMrBase}
              />
            </Col>
            <Col xs={12} md={4}>
              <Dropdown
                title="RWA CCR"
                options={rwaCcrArray}
                onChange={(value) => this.onChange("rwaCcrBase", value)}
                value={this.state.rwaCcrBase}
              />
            </Col>
            <Col xs={12} md={4}>
              <Dropdown
                title="RWA CVA"
                options={rwaCvaArray}
                onChange={(value) => this.onChange("rwaCvaBase", value)}
                value={this.state.rwaCvaBase}
              />
            </Col>
          </Row>
          <Row>
            <Col xs={12} md={4}>
              <Dropdown
                title="RWA COR"
                options={rwaCorArray}
                onChange={(value) => this.onChange("rwaCorBase", value)}
                value={this.state.rwaCorBase}
              />
            </Col>
            <Col xs={12} md={4}>
              <Dropdown
                title="RWA IRRBB"
                options={rwaIrrbbArray}
                onChange={(value) => this.onChange("rwaIrrbbBase", value)}
                value={this.state.rwaIrrbbBase}
              />
            </Col>
          </Row>
        </div>
      </Grid>
    );
  }
}

const hudrleRateArray = [
  { label: "ROE", value: "ROE" },
  { label: "WACC", value: "WACC" },
  { label: "Previous profit margin", value: "Previous profit margin" },
  { label: "Target profit margin", value: "Target profit margin" },
];

const rwaMrArray = [
  { label: "Eop balance contribution", value: "Eop balance contribution" },
  { label: "Revenue contribution", value: "Revenue contribution" },
  { label: "Previous RWA contribution", value: "Previous RWA contribution" },
];

const rwaCvaArray = [
  { label: "Eop balance contribution", value: "Eop balance contribution" },
  { label: "Revenue contribution", value: "Revenue contribution" },
  { label: "Previous RWA contribution", value: "Previous RWA contribution" },
];

const rwaCcrArray = [
  { label: "Eop balance contribution", value: "Eop balance contribution" },
  { label: "Revenue contribution", value: "Revenue contribution" },
  { label: "Previous RWA contribution", value: "Previous RWA contribution" },
];

const rwaCorArray = [
  { label: "Eop balance contribution", value: "Eop balance contribution" },
  { label: "Revenue contribution", value: "Revenue contribution" },
  { label: "Previous RWA contribution", value: "Previous RWA contribution" },
];

const rwaIrrbbArray = [
  { label: "Eop balance contribution", value: "Eop balance contribution" },
  { label: "Revenue contribution", value: "Revenue contribution" },
  { label: "Previous RWA contribution", value: "Previous RWA contribution" },
];



// WEBPACK FOOTER //
// src/pages/Raroc/UploadFile/Options.js